module.exports = __webpack_public_path__ + "img/avatarArtboard-4.6f50e014.svg";